module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAXCAYAAAARIY8tAAAACXBIWXMAAAsSAAALEgHS3X78AAAA/klEQVRIx7WUwXHCMBBFn1UB5qgLpALoADdgWojpIC2kAzoAVwCjBqKU4BJyMEcNVOBcGAaMsNZG/jM6rA7vaWe0m9RpPgEssCCcP+BLO3NEGAVshXCAGXA4TddFH8Hc88pQdlKJatWldmYOlLEkbYGlX4KSpE5zC6zu7n5btSQb7cxe0gED4J2dKOLFK4kp8EpiC54kCjiPKUnqNM+AH8bJh9LOWOFgDUmhALQzxUgSmzRNc6tO0/Ue+IwEr7Qzy4dfFLGTCsi83zSCpAIy7cz55Ry8IXmAdw7aAMkTPDjJPSReuGhVCCQv4eJd1CHphPdadlfJN3C5njIEB/gHcSxrerATPAwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_etiqueta_magenta.png
// module id = 204
// module chunks = 0